module.exports = "/static/Images/es/Seven.png";